module.exports = __webpack_public_path__ + "static/media/nauka-programowania-dla-dzieci-inf2-4.126e48d3.png";